<template>
  <v-card class="hoverCard" fill-height :style="'height:200px;margin:5px;background-color:' + color + ';'" v-on:click="select(currentFault)" v-on:mouseleave="hover = false" v-on:mouseover="hover = true">
    <v-container fluid grid-list-md style="padding:5px;height:100%;">
      <v-layout row fill-height>
        <v-flex d-flex md9>
          <v-layout column>
            <v-flex d-flex md3 style="align-items:center;">
              <img style="max-height:25px;max-width:25px;" :src="img" alt="">
              <div style="display:flex;align-items:center;margin-left:5px;font-size:22px;"> {{ currentFault.fault }}</div>
            </v-flex>
            <v-flex d-flex md3>
              <div style="margin-left:30px;color:rgb(115,115,115);">Fault</div>
            </v-flex>
            <v-flex d-flex md4>
              <v-layout row>
                <v-flex d-flex md4 style="margin-left:30px;font-size:30px;align-items:flex-end;">{{ currentFault.events.length }}</v-flex>
                <v-flex d-flex md8 style="font-size:16px;align-items:flex-end;">{{ currentFault.startDate | dateFormatter }}</v-flex>
              </v-layout>
            </v-flex>
            <v-flex d-flex md2>
              <v-layout row>
                <v-flex d-flex md4 style="margin-left:30px;color:rgb(115,115,115);">
                  <v-layout column wrap>
                    <v-flex d-flex sm12 :class="'twin-title-top'">Occurrences</v-flex>
                    <v-flex d-flex sm12 :class="'twin-title-bottom'">(Minutes)</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex d-flex md8 style="color:rgb(115,115,115);">First appeared</v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex d-flex md3>
           <v-layout v-if="!wingd_user" column>
            <v-flex d-flex md4 style="font-size:16px;align-items:flex-end;">{{ currentFault.element }} {{ currentFault.index }}</v-flex>
            <v-flex d-flex md2 style="color:rgb(115,115,115);">Element</v-flex>
            <v-flex d-flex md4 style="font-size:16px;align-items:flex-end;">{{ currentFault.component }}</v-flex>
            <v-flex d-flex md2 style="color:rgb(115,115,115);">Subsystem</v-flex>
          </v-layout>
          <v-layout v-else column>
            <v-flex v-if="currentFault.code" d-flex md1 style="font-size:14px;align-items:flex-end;">           
              <span >{{currentFault.code}}</span>      
            </v-flex>  
            <v-flex v-if="!currentFault.valid" d-flex md1 style="font-size:14px;align-items:flex-end;">      
              <span  title="Visible only to WinGD">Non-validated</span>
            </v-flex>
            <v-flex v-if="currentFault.code || !currentFault.valid" d-flex md2 style="color:rgb(115,115,115);">Fault rule</v-flex>
            <v-flex d-flex md2 style="font-size:14px;align-items:flex-end;">{{ currentFault.element }} {{ currentFault.index }}</v-flex>
            <v-flex d-flex md2 style="color:rgb(115,115,115);">Element</v-flex>
            <v-flex d-flex md2 style="font-size:14px;align-items:flex-end;">{{ currentFault.component }}</v-flex>
            <v-flex d-flex md2 style="color:rgb(115,115,115);">Subsystem</v-flex>
          </v-layout>
          <!-- <v-layout v-if="!wingd_user || currentFault.valid" column>            
            <v-flex d-flex md4 style="font-size:16px;align-items:flex-end;">{{ currentFault.element }} {{ currentFault.index }}</v-flex>
            <v-flex d-flex md2 style="color:rgb(115,115,115);">Element</v-flex>
            <v-flex d-flex md4 style="font-size:16px;align-items:flex-end;">{{ currentFault.component }}</v-flex>
            <v-flex d-flex md2 style="color:rgb(115,115,115);">Subsystem</v-flex>
          </v-layout>
          <v-layout v-else column>
            <v-flex d-flex md2 style="font-size:14px;align-items:flex-end;">
              <span title="Visible only to WinGD">Non-validated</span>
            </v-flex>
            <v-flex d-flex md2 style="color:rgb(115,115,115);">Fault rule</v-flex>
            <v-flex d-flex md2 style="font-size:14px;align-items:flex-end;">{{ currentFault.element }} {{ currentFault.index }}</v-flex>
            <v-flex d-flex md2 style="color:rgb(115,115,115);">Element</v-flex>
            <v-flex d-flex md2 style="font-size:14px;align-items:flex-end;">{{ currentFault.component }}</v-flex>
            <v-flex d-flex md2 style="color:rgb(115,115,115);">Subsystem</v-flex>
          </v-layout>-->
        </v-flex>
        <img v-if="currentFault.hasTicket" style="width: 20px; height: 20px; position: absolute; top: 10px; right: 8px;" :src="ticket" title="Ticket exists" alt="">
      </v-layout>
    </v-container>
  </v-card>

</template>

<script>
import CircGauge from "./CircGauge";
import {
  DxCircularGauge,
  DxSize,
  DxValueIndicator,
  DxGeometry,
  DxScale,
  DxRangeContainer,
  DxRange,
  DxTitle,
  DxLabel
} from "devextreme-vue/circular-gauge";
import {globalStore, vessels} from "../main.js"

export default {
  name: "FaultCard",
  components: {
    DxCircularGauge,
    DxSize,
    DxValueIndicator,
    DxGeometry,
    DxScale,
    DxRangeContainer,
    DxRange,
    DxTitle,
    DxLabel,
    CircGauge
  },
  props: {
    currentFault: Object,
    kpi: Object,
    selFaultId: Number,
    selFaultDate: String,
  },
  data() {
    return {
      red: require('../assets/colordotsred.png'),
      orange: require('../assets/colordotsorange.png'),
      ticket: require('../assets/ticket-blue.png'),
      hover: false
    }
  },
  filters: {
    dateFormatter: function (value) {
      if (!value)
        return '';

      let d = new Date(value + '.000Z');
      return d.toISOString().substring(0, 16).replace('T', ' ');
    }
  },
  methods: {
    select: function (fault) {
      this.$emit('faultChange', fault.Id);
    }
  },
  watch: {},
  computed: {
    img: function () {
      if (this.currentFault.color == 20)
        return this.red;
      else
        return this.orange;
    },
    color: function () {
      if ((this.selFaultId == this.currentFault.Id && this.currentFault.endDate.indexOf(this.selFaultDate) >= 0) || this.hover)
        return 'rgb(219,219,219)';
      else
        return 'rgb(255,255,255)';
    },
    wingd_user: () => {
      return globalStore.userProfile.roles.indexOf('ROLE_WINGD_SUPER_ADMIN') >= 0 ||
          globalStore.userProfile.roles.indexOf('ROLE_WINGD_ADMIN') >= 0 ||
          globalStore.userProfile.roles.indexOf('ROLE_WINGD_USER') >= 0;
    }
  },
  mounted() {
  },
}
</script>

<style scoped>
.hoverCard:hover {
  background-color: rgb(219, 219, 219);
}

.twin-title-top {
  padding-bottom: 0 !important;
}

.twin-title-bottom {
  padding-top: 0 !important;
  font-size: 10px;
  line-height: 10px !important;
}
</style>
